import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';

const savedSearchAPI = new Api('saved_searches');
const savedSearchDeleteAPI = new Api('saved_searches/:id');

function* createSavedSearch({ payload }) {
  try {
    const { filters, name, gridType, filter, setAsDefault } = payload;

    const result = yield call(
      sendRequest,
      savedSearchAPI.createItem,
      {
        data: {
          saved_search: {
            name,
            default: setAsDefault,
            grid: gridType,
            filter,
            filters,
          },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(actions.createSavedSearchSuccess());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteSavedSearch({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, savedSearchDeleteAPI.deleteItem, { id }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(actions.deleteSavedSearchSuccess());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.CREATE_SAVED_SEARCH_REQUEST, createSavedSearch)]);
  yield all([takeEvery(actions.DELETE_SAVED_SEARCH_REQUEST, deleteSavedSearch)]);
}
